/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangePasswordDto } from '../models/ChangePasswordDto';
import type { FindPasswordDto } from '../models/FindPasswordDto';
import type { LoginResultDto } from '../models/LoginResultDto';
import type { LoginWithEmailDto } from '../models/LoginWithEmailDto';
import type { MobileVeritificationResultDto } from '../models/MobileVeritificationResultDto';
import type { SignUpDto } from '../models/SignUpDto';
import type { VerifyMobileDto } from '../models/VerifyMobileDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuthService {
  /**
   * 로그인
   * @returns LoginResultDto
   * @throws ApiError
   */
  public static authControllerLoginByEmail({
    requestBody,
  }: {
    requestBody: LoginWithEmailDto;
  }): CancelablePromise<LoginResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/login',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 회원가입
   * @returns LoginResultDto
   * @throws ApiError
   */
  public static authControllerSignup({
    requestBody,
  }: {
    requestBody: SignUpDto;
  }): CancelablePromise<LoginResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/signup',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 휴대폰 인증
   * @returns MobileVeritificationResultDto
   * @throws ApiError
   */
  public static authControllerVerifyPhone({
    requestBody,
  }: {
    requestBody: VerifyMobileDto;
  }): CancelablePromise<MobileVeritificationResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/mobile',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 비밀번호 찾기
   * @returns MobileVeritificationResultDto
   * @throws ApiError
   */
  public static authControllerFindPassword({
    requestBody,
  }: {
    requestBody: FindPasswordDto;
  }): CancelablePromise<MobileVeritificationResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/find-password',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 비밀번호 변경
   * @returns MobileVeritificationResultDto
   * @throws ApiError
   */
  public static authControllerChangePassword({
    requestBody,
  }: {
    requestBody: ChangePasswordDto;
  }): CancelablePromise<MobileVeritificationResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/change-password',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
